<template>
  <section v-if="!appConfig.capacitorApp" class="desktop-install">
    <nav class="conversation-tool-list">
      <button type="button" :disabled="desktopInstall.busy" @click="install"><span aria-hidden="true">▣</span><strong>{{ language.t('install.add') }}</strong><small>›</small></button>
    </nav>
    <div v-if="notice" class="desktop-install-notice" role="status">
      <p>{{ language.t(`install.${notice}`) }}</p>
      <button type="button" class="ghost-inline-action" @click="notice = ''">{{ language.t('common.close') }}</button>
    </div>
  </section>
</template>
<script setup>
import { ref } from 'vue';
import { appConfig } from '@/config';
import { useLanguageStore } from '@/stores/language';
import { desktopInstall, requestDesktopInstall } from '@/services/desktopInstall';
const language = useLanguageStore();
const notice = ref('');
async function install() { notice.value = await requestDesktopInstall(); }
</script>
<style scoped>
.desktop-install-notice { margin: 8px 0 12px; padding: 12px; border: 1px solid var(--border-color, #ccd7df); border-radius: 8px; overflow-wrap: anywhere; }
.desktop-install-notice p { margin: 0 0 8px; line-height: 1.6; }
</style>
